import { render, staticRenderFns } from "./NAVOnlineInvoiceInterfacePanel.yaml?vue&type=template&id=5bcd797e&component"
import script from "./NAVOnlineInvoiceInterfacePanel.yaml?vue&type=script&lang=ts&component"
export * from "./NAVOnlineInvoiceInterfacePanel.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports